<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { RouterView } from 'vue-router'
import { useSessionStore } from '@/store/useSessionStore'

const session = useSessionStore()

async function checkSession() {
  if (!session.isAuthenticated) return
  await session.fetchSession()
}

function onVisibilityChange() {
  if (document.visibilityState === 'visible') checkSession()
}

onMounted(() => document.addEventListener('visibilitychange', onVisibilityChange))
onUnmounted(() => document.removeEventListener('visibilitychange', onVisibilityChange))
</script>

<template>
  <RouterView />
</template>
